import productModule from "./productModule"

productModule.controller("productController", ["$scope", "sourceEntity", "entity", "entityEditionService", "autocompleteFactory", ($scope, sourceEntity, entity, entityEditionService, autocompleteFactory) => {
    const updateService = entityEditionService.crudHelper("product", sourceEntity)
    $scope.entity = entity
    $scope.getProductCategories = autocompleteFactory.lazyLoader("productCategory")

    $scope.save = updateService.save.bind(updateService, entity)

    $scope.saveAndContinue = updateService.save.bind(updateService, entity, true)

    $scope.currentFractionalProductType = getCurrentFractionalProductType()

    function getCurrentFractionalProductType() {
        if (!$scope.entity.fractionalProductType) {
            return "br.com.neolog.model.product.FractionalProductType.WEIGHT"
        }
        return $scope.entity.fractionalProductType
    }

    $scope.enableFractionalConfigButton = () => {
        let entity = $scope.entity
        let enableFractionalConfig = entity.enableFractionalConfig
        if (enableFractionalConfig) {
            return entity.fractionalProductType = $scope.currentFractionalProductType
        }
        $scope.currentFractionalProductType = entity.fractionalProductType
        return entity.fractionalProductType = null
    }
}])